import { Toggle, Heading, Label, Select, Surface, Text } from '@elladx/design-system';
import type { NotificationSettings } from '../../types';
interface NotificationsSectionProps {
    notifications: NotificationSettings;
    onChange: (field: keyof NotificationSettings, value: string | boolean) => void;
}
function NotificationsSection({ notifications, onChange }: NotificationsSectionProps) {
    return (<Surface className="form-section">
      <Heading as="h2" variant="card">Notifications</Heading>
      <Text className="section-description">Configure email notifications and tracking updates.</Text>

      <div className="form-grid-settings">
        <div className="form-group full-width">
          <Label className="checkbox-label">
            <Toggle checked={notifications.email_notifications} onChange={(e) => onChange('email_notifications', e.target.checked)}/>
            Enable email notifications
          </Label>
          <Text className="field-hint">Receive email alerts for shipment updates and errors.</Text>
        </div>

        <div className="form-group full-width">
          <Label className="checkbox-label">
            <Toggle checked={notifications.send_tracking_emails} onChange={(e) => onChange('send_tracking_emails', e.target.checked)}/>
            Send tracking emails to recipients
          </Label>
          <Text className="field-hint">Automatically send tracking information to recipients after label purchase.</Text>
        </div>

        <div className="form-group">
          <Label htmlFor="tracking-template">Tracking Email Template</Label>
          <Select id="tracking-template" value={notifications.tracking_email_template} onChange={(e) => onChange('tracking_email_template', e.target.value)}>
            <option value="default">Default Template</option>
            <option value="minimal">Minimal</option>
            <option value="detailed">Detailed</option>
          </Select>
        </div>
      </div>
    </Surface>);
}
export default NotificationsSection;
